import { useSwrNoAuth } from "../../swr/useSwrNoAuth";

export const useFetchBusinessTitleByRestaurantId = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `/external_api/restaurants/${restaurantId}/google/business-information/` : null;
  const { data: businessTitle, error, isLoading } = useSwrNoAuth<string>(fetcherKey);
  return { businessTitle, isLoading, error };
};